import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { getCurrentUserSubscriptionId, getCurrentUserSubscription } from './currentUserSelector';

import { updateCurrentUser } from './currentUserActions';
import { fetchCurrentUserSubscription } from './currentUserSubscriptionActions';

import usePrevious from '../utils/react/usePrevious';

const mapStateToProps = createStructuredSelector({
    subscriptionId: getCurrentUserSubscriptionId,
    subscription: getCurrentUserSubscription,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchFetchCurrentUserSubscription: () => dispatch(fetchCurrentUserSubscription()),
    dispatchClearCurrentUserSubscription: () =>
        dispatch(
            updateCurrentUser({
                changes: {
                    subscription: null,
                    subscriptionMeta: null,
                },
                sync: false,
            }),
        ),
});

const CurrentUserSubscriptionSynchroniser = ({
    subscriptionId,
    subscription,
    dispatchFetchCurrentUserSubscription,
    dispatchClearCurrentUserSubscription,
}) => {
    const previousSubscriptionId = usePrevious(subscriptionId);

    useEffect(() => {
        if (subscriptionId === previousSubscriptionId) return;

        if (subscriptionId) {
            dispatchFetchCurrentUserSubscription();
        } else {
            dispatchClearCurrentUserSubscription();
        }
    }, [subscriptionId, subscription]);

    return null;
};

CurrentUserSubscriptionSynchroniser.propTypes = {
    subscriptionId: PropTypes.string,
    subscription: PropTypes.object,
    dispatchFetchCurrentUserSubscription: PropTypes.func,
    dispatchClearCurrentUserSubscription: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(CurrentUserSubscriptionSynchroniser);
